if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        if (!this.hasAttribute('available')) return;

        this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.getAttribute('data-variant-id'));
      }

      fetchAvailability(variantId) {
        let rootUrl = this.getAttribute('data-root-url');
        if (!rootUrl.endsWith('/')) {
          rootUrl = rootUrl + '/';
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((responseText) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector('.shopify-section');
            this.renderPreview(sectionInnerHTML);
          })
          .catch(() => {
            const button = this.querySelector('button');
            if (button) button.removeEventListener('click', this.onClickRefreshList);
            this.renderError();
          });
      }

      onClickRefreshList() {
        this.fetchAvailability(this.getAttribute('data-variant-id'));
      }

      update(variant) {
        if (variant?.available) {
          // Update the attribute on the DOM so the API script knows the size changed
          this.setAttribute('data-variant-id', variant.id); 
          this.fetchAvailability(variant.id);
        }
        else {
          this.innerHTML = '';
          this.removeAttribute('available');
          this.setAttribute('hidden', '');
        }
      }

      renderError() {
        this.innerHTML = '';
        this.appendChild(this.errorHtml);

        this.querySelector('button').addEventListener('click', this.onClickRefreshList);
      }

      renderPreview(sectionInnerHTML) {
        const drawer = document.querySelector('.pickup-availability-drawer');
        if (drawer) drawer.remove();
        if (!sectionInnerHTML.querySelector('.pickup-availability-preview')) {
          this.innerHTML = '';
          this.removeAttribute('available');
          this.setAttribute('hidden', '');
          return;
        }

        this.innerHTML = sectionInnerHTML.querySelector('.pickup-availability-preview').outerHTML;
        this.removeAttribute('hidden');
        this.setAttribute('available', '');

        document.body.appendChild(sectionInnerHTML.querySelector('.pickup-availability-drawer'));
      }
    }
  );
}

// ── Custom: Storefront API pickup label enhancement ──
(function () {
  const TOKEN = '47392f081b72fb8ccffde36c19da6380';
  const IN_STORE_TIME_TEXT = 'Usually ready in 4 hours';

  async function fetchStoreAvailability(variantId) {
    try {
      const res = await fetch('/api/2025-10/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': TOKEN
        },
        body: JSON.stringify({
          query: `query($id:ID!){node(id:$id){...on ProductVariant{
            storeAvailability(first:10){nodes{available pickUpTime quantityAvailable location{name}}}}}}`,
          variables: { id: `gid://shopify/ProductVariant/${variantId}` }
        })
      });
      const json = await res.json();
      // Debug console log removed for production privacy
      return json?.data?.node?.storeAvailability?.nodes || [];
    } catch (e) {
      console.error('Storefront API Error:', e);
      return [];
    }
  }

  function applyLabels(nodes) {
    if (!nodes.length) return;

    // SVG markup for the two icon states (extracted from existing icons on the page)
    const getIconSvg = (item, iconName) => {
      const existingIcon = item.querySelector(`.icon-${iconName}`);
      return existingIcon ? existingIcon.outerHTML : null;
    };

    // Find any check-circle and alert-circle icon on the page to use as templates
    const checkIconTemplate = document.querySelector('.icon-check-circle-filled')?.outerHTML;
    const alertIconTemplate = document.querySelector('.icon-alert-circle-filled')?.outerHTML;

    // Pick the in-stock location for the preview (first one with qty > 0)
    const inStockNode = nodes.find(n => n.quantityAvailable > 0);
    const bestNode = inStockNode || nodes[0];

    const preview = document.querySelector('pickup-availability .pickup-availability-preview');
    if (preview) {
      const isInStore = bestNode.quantityAvailable > 0;
      const info = preview.querySelector('.pickup-availability-info');
      const currentSvg = info?.querySelector('svg');
      
      // Swap the icon if needed
      if (currentSvg && checkIconTemplate && alertIconTemplate) {
        const desiredTemplate = isInStore ? checkIconTemplate : alertIconTemplate;
        const currentIsCheck = currentSvg.classList.contains('icon-check-circle-filled');
        if (isInStore !== currentIsCheck) {
          currentSvg.outerHTML = desiredTemplate;
        }
      }
      
      // Re-query after potential outerHTML swap
      const svg = info?.querySelector('svg');
      if (svg) {
        svg.classList.add('shrink-0');
        svg.classList.toggle('pickup-icon--instore', isInStore);
        svg.classList.toggle('pickup-icon--transfer', !isInStore);
      }

      const p = preview.querySelector('p');
      const small = preview.querySelector('small');
      if (p) {
        p.className = `text-sm font-medium leading-tight ${isInStore ? 'pickup-status--instore' : 'pickup-status--transfer'}`;
        p.innerHTML = `${isInStore ? 'In-store' : 'Available'} &middot; ${bestNode.location.name}`;
      }
      if (small) {
        small.textContent = isInStore ? IN_STORE_TIME_TEXT : bestNode.pickUpTime;
      }
    }

    // Update each row in the modal
    document.querySelectorAll('.pickup-availability-list__item').forEach(item => {
      const name = item.querySelector('h4')?.textContent?.trim();
      const node = nodes.find(n => n.location.name === name);
      if (!node) return;
      const isInStore = node.quantityAvailable > 0;
      const info = item.querySelector('.pickup-availability-info');
      const currentSvg = info?.querySelector('svg');

      // Swap the icon if needed
      if (currentSvg && checkIconTemplate && alertIconTemplate) {
        const desiredTemplate = isInStore ? checkIconTemplate : alertIconTemplate;
        const currentIsCheck = currentSvg.classList.contains('icon-check-circle-filled');
        if (isInStore !== currentIsCheck) {
          currentSvg.outerHTML = desiredTemplate;
        }
      }

      // Re-query after potential outerHTML swap
      const svg = info?.querySelector('svg');
      if (svg) {
        svg.classList.add('shrink-0');
        svg.classList.toggle('pickup-icon--instore', isInStore);
        svg.classList.toggle('pickup-icon--transfer', !isInStore);
      }

      const p = item.querySelector('p');
      if (p) {
        p.className = `text-sm leading-tight ${isInStore ? 'pickup-status--instore' : 'pickup-status--transfer'}`;
        p.textContent = `${isInStore ? 'In-store' : 'Available'} \u00B7 ${isInStore ? IN_STORE_TIME_TEXT.toLowerCase() : node.pickUpTime.toLowerCase()}`;
      }
    });
  }

  function runForVariant(variantId) {
    if (!variantId) return;
    fetchStoreAvailability(variantId).then(applyLabels);
  }

  document.addEventListener('DOMContentLoaded', () => {
    const pickupEl = document.querySelector('pickup-availability');
    if (!pickupEl) return;

    // Watch for the preview being injected or replaced
    new MutationObserver(() => {
      if (pickupEl.querySelector('.pickup-availability-preview')) {
        runForVariant(pickupEl.getAttribute('data-variant-id'));
      }
    }).observe(pickupEl, { childList: true, subtree: true });

    // Watch for variant ID changes on the element itself (variant change)
    new MutationObserver(() => {
      runForVariant(pickupEl.getAttribute('data-variant-id'));
    }).observe(pickupEl, { attributes: true, attributeFilter: ['data-variant-id'] });

    // Watch for drawer being appended to body
    new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (node.classList?.contains('pickup-availability-drawer')) {
            runForVariant(pickupEl.getAttribute('data-variant-id'));
          }
        }
      }
    }).observe(document.body, { childList: true });

    // Run immediately if the preview is already there on page load
    if (pickupEl.querySelector('.pickup-availability-preview')) {
      runForVariant(pickupEl.getAttribute('data-variant-id'));
    }
  });
})();